import Icon from '../Icon.vue'

Icon.register({
  'alert_lightning': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M13.974 11.25l-5.483 6.1a.755.755 0 01-1.004.13.89.89 0 01-.319-1.03l1.684-4.77L6.36 9.825a.876.876 0 01-.34-.621.898.898 0 01.22-.68l5.48-6.101a.758.758 0 011.005-.13c.32.218.453.648.32 1.03l-1.684 4.77 2.492 1.854a.876.876 0 01.34.621.893.893 0 01-.22.681l.001.001zM10 0C4.485 0 0 4.486 0 10s4.485 10 10 10c5.514 0 10-4.486 10-10S15.514 0 10 0z'
      }
    ]
  }
})
